__turbopack_context__.v({
  "badge": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__badge",
  "boatCardWrapper": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__boatCardWrapper",
  "carouseWrapper": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__carouseWrapper",
  "carouselHeader": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__carouselHeader",
  "container": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__container",
  "containerCarousel": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__containerCarousel",
  "contentMore": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__contentMore",
  "contentTitle": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__contentTitle",
  "moreLink": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__moreLink",
  "moreText": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__moreText",
  "navButtonContainer": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__navButtonContainer",
  "primary": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__primary",
  "publicBoatCardStyle": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__publicBoatCardStyle",
  "secondary": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__secondary",
  "slick-disabled": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__slick-disabled",
  "slick-next": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__slick-next",
  "slick-prev": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__slick-prev",
  "title": "ExplorerBoatsCarousel-module-scss-module__-rkZHW__title",
});
